import React from 'react';
import './Card.css';

interface CardProps {
  title: string;
  value: string;
  subvalue?: string;
  valueClassName?: string;
  subvalueClassName?: string;
}

export const Card: React.FC<CardProps> = ({
  title,
  value,
  subvalue,
  valueClassName = '',
  subvalueClassName = ''
}) => {
  return (
    <div className="card">
      <h3 className="card-title">{title}</h3>
      <div className={`card-value ${valueClassName}`}>{value}</div>
      {subvalue && (
        <div className={`card-subvalue ${subvalueClassName}`}>{subvalue}</div>
      )}
    </div>
  );
};
